<template>
	<a :aria-disabled="isLoaded" class="btn-center btn-cu btn-l btn-fw btn-color-estandar" :href="urlSignIn">
		<span class="cl-claveunica" :style="iconStyle"></span>
		<span class="texto">Iniciar sesión</span>
	</a>
	<!-- <div class="text-center">
		<span class="text-caption">{{ $t('claveUnica.inicioSesionCaption') }}</span>
		<a :aria-disabled="isLoaded" class="btn-center btn-cu btn-l btn-fw btn-color-estandar" :href="urlSignIn">
			<span class="cl-claveunica" :style="iconStyle"></span>
			<span class="texto">Iniciar sesión</span>
		</a>
		<a :aria-disabled="isLoaded" class="btn-center btn-cu btn-l btn-fw btn-color-estandar" @click="login">
			<span class="cl-claveunica" :style="iconStyle"></span>
			<span class="texto">Iniciar sesión</span>
		</a>
	</div> -->
</template>

<script>

import claveUnicaIcono from '@/assets/cu-blanco.svg'
import providersMixins from './providersMixins';

export default {
	mixins: [providersMixins],
	computed:{
	},
	data () {
		return {
			iconStyle: `background-image: url('${claveUnicaIcono}');`
		};
	},
	methods:{
		async login(){

			const token = '?state=<tokenSesion>&code=<tokenAutorizacion>';

			return this.$router.push('/emitir/'+token);
			
			let respSignin = await this.$store.dispatch('usuario/signIn', {
				username: '76431892-7',
				pass: 'vessi.2020',
				versionCheckeada: true
			});
			
			if(respSignin===false){
				return;
			}if( this.$store.getters['usuario/authStatus'] === 'authenticated' ){

				if( !!respSignin ){
				
					// this.$router.push({name: '3rdSignIn', query: { token: token } });
				this.$router.push('/emitir/'+token)
				}else{
					this.showMessage('error', 'Ha ocurrido un error, vuelva a intentarlo más tarde');
				}
			}else{

				let error = this.$store.state.usuario.auth.error;

				if( error.hasOwnProperty('response') ){

					let msg = '';

					switch( error.response.status ){
						case 400:
							msg = 'Usuario y/o contraseña incorrectos.';
						break;
						break;
						case 404:
							msg = 'Usuario y/o contraseña incorrectos.';
						break;
						case 500:
							msg = 'Ha ocurrido un error, vuelva a intentarlo más tarde';
						break;
						default:
							msg = 'Ha ocurrido un error, vuelva a intentarlo más tarde';
					}
				}else{

				}

			}
		}
	},
	mounted(){
		
	}
}


</script>

<style>

	.btn-center {
		margin: auto;
	}

/* Boton estilo de base */
	.btn-cu {
		display: inline-block;
		font-family: Roboto, sans-serif;
		font-weight: 400;
		text-align: center;
		vertical-align: middle;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;
		border-radius: 0;
	}

	/* Boton estilo con isotipo */
	.cl-claveunica-logo {
		display: inline-block;
		font-family: Roboto, sans-serif;
		font-weight: 400;
		text-align: center;
		vertical-align: middle;
	}

	/* Tamaño M */
	.btn-cu.btn-m {
		width: 160px;
		min-width: 160px;
		max-height: 42px;
		padding: 8px 18px 8px 15px !important;
		font-size: 16px;
		line-height: 1.6em;
	}
	.btn-cu.btn-m .cl-claveunica {
		display: inline-block;
		width: 24px;
		height: 24px;
		background-size: 24px 24px;
	}

	/*Icono ClaveÚnica*/
	.btn-cu .cl-claveunica {
		display: inline;
		float: left;
		text-indent: -9999px;
	}
	/*Texto ClaveÚnica*/
	.btn-cu .texto {
		padding-left: 3px;
		text-decoration: underline;
	}

	.btn-cu.btn-fw {
		max-width: 550px;
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.btn-cu.btn-color-estandar {
		background-color: #0F69C4;
		color: #FFF;
	}

	.btn-cu.btn-color-estandar:hover {
		background-color: #0C549C;
		color: #FFF;
	}

	.btn-cu.btn-color-estandar:active {
		background-color: #093F75;
		color: #FFF;
	}

	.btn-cu.btn-color-estandar:focus {
		background-color: #0C549C;
		color: #FFF;
		outline: 1px dashed #000;
	}

	/* Tamaño L */
	.btn-cu.btn-l {
		/* width: 180px; */
		min-width: 180px;
		/* max-height: 48px; */
		padding: 11px 18px !important;
		font-size: 23px;
	}

	/* .btn-cu.btn-l .cl-claveunica {
		width: 26px;
		height: 26px;
		background-size: 26px 26px;
	} */

	.btn-cu.btn-l .cl-claveunica {
		width: 36px;
    height: 36px;
    background-size: 36px 36px;
	}

</style>